import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgOutilIcon(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={27} height={27} fill="none" viewBox="0 0 27 27" {...props}>
            <Path
                fill="#A7D2D7"
                d="M8.369 17.479l3.772-3.772 1.12 1.12L9.49 18.6l-1.12-1.12zm6.096-6.095l7.803-7.804 1.12 1.12-7.803 7.804-1.12-1.12z"
            />
            <Path
                fill="#7BA0B0"
                d="M15.025 11.944l7.804-7.803.56.56-7.804 7.804-.56-.56zm-6.096 6.094l3.772-3.772.56.56-3.772 3.772-.56-.56z"
            />
            <Path
                fill="#E4EBEF"
                d="M24.062 25.796l-2.854-2.854 2.548-2.548 2.854 2.854a4.847 4.847 0 00-1.03-5.335c-1.103-1.104-2.462-1.419-3.778-1.114-.44.101-1.429.492-1.748.173L9.97 6.887c-.313-.314.076-1.294.17-1.728.277-1.295-.045-2.625-1.13-3.71A4.847 4.847 0 003.674.421l2.854 2.853L3.98 5.822 1.126 2.968a4.847 4.847 0 001.029 5.335c1.104 1.104 2.462 1.42 3.779 1.115.44-.102.9.036 1.22.355l10.084 10.085c.314.314.453.765.36 1.2-.278 1.294.044 2.624 1.129 3.709a4.847 4.847 0 005.335 1.029z"
            />
            <Path
                fill={baseColors.green.primary}
                d="M.88 26.092a3.002 3.002 0 01.159-4.394l6.933-5.675 2.977 2.976-5.676 6.934a3.002 3.002 0 01-4.393.159z"
            />
            <Path
                fill={baseColors.green.dark}
                d="M.88 26.091a3.002 3.002 0 004.393-.158l5.675-6.934-1.488-1.488-8.58 8.58z"
            />
            <Path fill="#C7E2E5" d="M24.397.324l2.19 2.191-2.689 2.69-2.19-2.192L24.397.324z" />
            <Path
                fill={baseColors.green.pastel}
                d="M4.243 23.848l-2.728 2.73a3.005 3.005 0 01-1.121-1.12l2.729-2.73a.792.792 0 111.12 1.12zm5.05-2.827l-1.101 1.346-3.588-3.588 1.346-1.101 3.343 3.343z"
            />
            <Path
                fill="#C7E2E5"
                d="M22.444 21.706L5.283 4.518l1.245-1.245L3.674.42A4.847 4.847 0 019.01 1.448c1.085 1.085 1.407 2.415 1.13 3.71a1.31 1.31 0 00.359 1.2l10.085 10.084c.319.32.78.457 1.22.356 1.315-.305 2.674.01 3.778 1.114a4.847 4.847 0 011.029 5.335l-2.854-2.854-1.312 1.313z"
            />
            <Path fill="#A7D2D7" d="M22.83 4.14l2.689-2.689 1.068 1.069-2.69 2.69-1.068-1.07z" />
            <Path
                fill={baseColors.green.pastel}
                d="M.879 26.092c.194.194.408.357.635.486l2.73-2.73a.792.792 0 000-1.12L.878 26.091zm5.518-5.519l1.794 1.794 1.102-1.346-1.672-1.671-1.224 1.223z"
            />
        </Svg>
    )
}

export default SvgOutilIcon
